import '/webpack-assets/scss/common/ui-kit.scss';

import { createApp } from 'vue';
import { loadMessages, translate } from '/webpack-assets/vue/utils/common';
import { requestWithHandler } from '/webpack-assets/vue/utils/requestHandler';

// Be advised to make your vue directory looks like this
// method could be placed in controller like index/site or index/authorization
// 
// ├───templates
// │   ├───controller
// │   │   ├───method
// │   │   │   ├───parts
// │   │   │   │   └───part.vue
// │   │   │   ├───style
// │   │   │   │   └───method.scss
// │   │   │   └───Method.vue

/**
 * @param {Object} options
 * @param {String} options.controller
 * @param {String} options.method
 * @param {Object} options.globalComponents
 * @param {Object} options.plugins
 * @param {Function} options.additionalSetup
 * @param {String} options.appID
 * @param {Function} [options.provide]
 */

export function createVueApp({ controller, method, globalComponents = {}, plugins = {}, additionalSetup = () => {}, appID, provide, namespaces = [] }) {
    const AppComponent = require(`/webpack-assets/vue/templates/${controller}/${method}.vue`).default;

    const app = createApp(AppComponent);
    const appIdentifier = appID || '#app';
    const language = window.common?.language.code2 || 'en';
    const { messages } = loadMessages(language, [controller], namespaces);

    app.config.globalProperties.$t = (keyOrParams, ...params) => translate(keyOrParams, messages, ...params);
    app.config.globalProperties.$request = requestWithHandler;

    Object.entries(globalComponents).forEach(([name, component]) => {
        app.component(name, component);
    });

    Object.values(plugins).forEach(plugin => {
        app.use(plugin);
    });

    if (provide) {
        Object.entries(provide()).forEach(([key, value]) => {
            app.provide(key, value);
        });
    }

    additionalSetup(app);

    app.mount(appIdentifier).$nextTick(() => {
        document.body.removeAttribute('v-cloak');
    });
    return app;
}